import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { TextField, Button, Chip } from '@material-ui/core'
import { recursoService } from '../../aplicacion/addRecurso'
import { etiquetaService } from '../../aplicacion/addEtiqueta'
import { destinatarioService } from '../../aplicacion/addDestinatario'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useParams } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 750,
    textAlign: 'center',
  },
  button: {
    marginTop: '30px',
  },
}))

export const Formulario = ({ onSearch }) => {
  const { id } = useParams()
  const classes = useStyles()
  const [nombre, setNombre] = useState('')
  const [destinatario, setDestinatario] = useState('')
  const [destOptions, setDestOptions] = useState([])
  const [descripcion, setDescripcion] = useState('')
  const [link, setLink] = useState('')
  const [imagenUrl, setImagenUrl] = useState('')
  const [etiquetas, setEtiquetas] = useState([])
  const [tagOptions, setTagOptions] = useState([])
  const [maxCharacters, setCharacters] = useState(250)

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const recurso = await recursoService.get(id)
        if (recurso) {
          setNombre(recurso.nombre)
          setDestinatario(recurso.destinatario)
          setDescripcion(recurso.descripcion)
          if (recurso.link) {
            setLink(recurso.link)
          }
          if (recurso.imagenUrl) {
            setImagenUrl(recurso.imagenUrl)
          }
          if (recurso.etiquetas) {
            setEtiquetas(recurso.etiquetas)
          }
        }
      }
    }
    fetchData()
  }, [id])

  useEffect(() => {
    const fetchData = async () => {
      const a = await etiquetaService.getAll()
      setTagOptions(a)
      const b = await destinatarioService.getAll()
      setDestOptions(b)
    }
    fetchData()
  }, [])

  const onDescriptionChange = value => {
    setDescripcion(value)
    setCharacters(250 - descripcion.length)
  }

  const submit = () => {
    if (nombre && destinatario && descripcion) {
      let a = {
        Nombre: nombre,
        Destinatario: destinatario,
        Descripcion: descripcion,
      }
      destinatarioService.add(destinatario)
      if (link) {
        a = { ...a, Link: link }
      }
      if (etiquetas) {
        const etiquetasSinEspacios = etiquetas.map(etiqueta => etiqueta.replace(/ /g, ''))
        a = { ...a, Etiquetas: etiquetasSinEspacios }
        etiquetaService.add(etiquetasSinEspacios)
      }
      if (imagenUrl) {
        a = { ...a, ImagenUrl: imagenUrl }
      }
      if (id) {
        a = { ...a, id }
      }
      if (!id) {
        recursoService.add(a)
      } else {
        recursoService.edit(a)
      }
      setNombre('')
      setDestinatario('')
      setDescripcion('')
      setLink('')
      setImagenUrl('')
      setEtiquetas([])
    } else {
      console.log('Hay que rellenar al menos los campos de Nombre, Destinatario y Descripción.')
    }
  }

  return (
    <header className="App-header">
      <div className={classes.root}>
        <div>
          <TextField
            required
            fullWidth
            id="name"
            label="Nombre del recurso"
            onChange={value => setNombre(value.target.value)}
            value={nombre}
          />
        </div>
        <div>
          <Autocomplete
            id="destinatarios-filled"
            size="small"
            freeSolo
            value={destinatario}
            options={destOptions.map(option => option.title)}
            renderDests={(value, getDestProps) =>
              value.map((option, index) => <Chip variant="outlined" label={option} {...getDestProps({ index })} />)
            }
            onChange={(a, dests, c) => setDestinatario(dests)}
            renderInput={params => (
              <TextField
                {...params}
                required
                multiline
                variant="standard"
                label="Destinatarios"
                helperText="¿A quién le puede servir este recurso? Por ejemplo: 'Público general' o 'Niños' o 'Empresarios'."
              />
            )}
          />
        </div>
        <div>
          <TextField
            required
            fullWidth
            id="description"
            label="Descripción"
            onChange={value => onDescriptionChange(value.target.value)}
            value={descripcion}
            multiline
            helperText={`Quedan ${maxCharacters} letras.`}
          />
        </div>
        <div>
          <TextField
            fullWidth
            id="url"
            label="Url del recurso"
            onChange={value => setLink(value.target.value)}
            value={link}
            helperText="Antes de introducir la url asegurate de que lleva bien a la página del recurso."
            multiline
          />
        </div>
        <div>
          <TextField
            fullWidth
            id="imagenUrl"
            label="Url de la imagen"
            onChange={value => setImagenUrl(value.target.value)}
            value={imagenUrl}
            helperText="Antes de introducir la url asegurate de que lleva bien a la imagen."
            multiline
          />
        </div>
        <div>
          <Autocomplete
            multiple
            id="tags-filled"
            size="small"
            freeSolo
            value={etiquetas}
            options={tagOptions.map(option => option.title)}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => <Chip variant="outlined" label={option} {...getTagProps({ index })} />)
            }
            onChange={(a, tags, c) => setEtiquetas(tags)}
            renderInput={params => <TextField {...params} multiline variant="standard" label="Etiquetas" />}
          />
        </div>
        <Button variant="contained" color="primary" className={classes.button} onClick={submit}>
          Enviar
        </Button>
      </div>
    </header>
  )
}
